module.exports = __webpack_public_path__ + "img/btn-header-back.56cc7f87.svg";